import { RouteHelper } from './../../helpers/route.helpers';
import { AuthService } from './../../services/auth/auth.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  constructor(
    public routeHelper: RouteHelper,
    private authService: AuthService
  ) {}

  forgotForm = new FormGroup({
    email: new FormControl('', Validators.required),
  });

  preloader: boolean;

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  get validating() {
    return this.forgotForm.controls;
  }

  async onSubmit() {
    this.preloader = true;
    const param = {
      email: this.forgotForm.value.email,
    };

    if (this.forgotForm.valid) {
      await this.authService
        .forgotPassword(param)
        .pipe(first())
        .subscribe(
          (data) => {
            Swal.fire('Success', data.message, 'success');
            this.preloader = false;
          },
          (error) => {
            Swal.fire('Ops!', error.message, 'error');
            this.preloader = false;
          }
        );
    }
  }
}
